<ng-container *transloco="let t">
  <div class="container"></div>
  @if (isLanding && isTopBannerVisible) {
    <app-top-banner/>
  }

  <header class="header d-flex align-items-center fixed-top {{ additionalClass }}"
          [ngClass]="{ 'fixed-top--with-banner': isLanding && isTopBannerVisible, 'landing': isLanding }">

    <div class="mobile-search-wrapper d-flex d-xxl-none" [@searchSlideInOut]="isSearchVisible ? 'visible' : 'hidden'"
         [ngClass]="{ 'mobile-search-wrapper--with-banner': isTopBannerVisible }">
      <div class="d-flex justify-content-center align-items-center w-100 px-3">
        <app-search-bar-events [isTransparent]="true"/>
      </div>
    </div>
    <div class="container py-0 navigation container--header">
      <div class="d-flex flex-wrap justify-content-between position-relative align-items-center">

        <!--        Logo image - XXL screen only-->
        <img src="assets/icons/tracey-alt-logo.svg" alt="Tracey logo"
             [style.width.px]="currentWindowWidth < 1400 ? 132 : 200" (click)="onClickToLogoImage()"
             class="cursor-pointer">

        <div class="d-flex align-items-center">
          <!--        Logged out - menu - XXL screen only-->
          <ul
            class="nav nav-alt col-12 col-xxl-auto justify-content-start mb-md-0 d-none d-xxl-flex align-items-center">
            <li [class.active]="isRouteActive('EVENT_CALENDAR')"><a (click)="onEventCalendar()">{{
                t(
                  'page.header.event.calendar')
              }}</a></li>
            <li [class.active]="isRouteActive('FINISHED')"><a (click)="goToFinished()">{{
                t(
                  'page.header.finished.events')
              }}</a></li>
            <li [class.active]="isRouteActive('LIVE_RESULTS')"><a (click)="goToLiveResults()">{{
                t(
                  'page.header.live.results')
              }}</a></li>
            @if (environment.isLeagueVisible) {
              <li [class.active]="isRouteActive('SERIES')"><a (click)="goToSeries()">{{
                  t(
                    'page.header.series')
                }}</a></li>
            }
            @if (authenticationService.isAuthenticated()) {
              <li [class.active]="isRouteActive('USER_PROFILE_VIEW_ROUTE')">
                <a (click)="goToMyTracey()">{{
                    t('app.common.myTracey')
                  }}
                </a>
              </li>
              <li (click)="onOrganiserButtonClick()">
                <a>
                  {{
                    t('page.header.organisers')
                  }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="d-flex align-items-center">
          <div class="d-none d-xxl-flex pe-3">
            <div class="d-flex align-items-center" (click)="openLanguagesModal()" style="cursor: pointer;">
              <i class="bi bi-globe2 me-2" style="color: white;"></i>
              <p class="small" style="color: white;">{{ activeLang }}</p>
            </div>
          </div>
          @if (authenticationService.isAuthenticated()) {
            <!--            <div class="d-none d-xxl-flex">-->
              <!--              <ng-container *ngTemplateOutlet="messageIcon; context: { unreadMessages: unreadMessages }"></ng-container>-->
              <!--            </div>-->
            <div class="d-none d-xxl-flex remove-dropdown-icon" ngbDropdown>
              <button type="button" class="btn p-0" id="myProfileDropdown" ngbDropdownToggle>
                <div class="profile-box">
                  @if (currentUserDetails?.picture) {
                    <div class="d-flex flex-row align-items-center">
                      <div class="pe-2">
                        <div class="avatar-arrow-down">
                          <img [src]="currentUserDetails!.picture" class="avatar" alt="Avatar"/>
                          <img src="assets/img/svg/arrow-down.svg" alt="Arrow down" class="cursor-pointer arrow-down">
                        </div>
                      </div>
                    </div>
                  } @else {
                    <div class="d-flex flex-row align-items-center">
                      <div class="pe-2">
                        <div class="avatar-arrow-down">
                          <div class="profile-box__initials">
                            <p>
                              {{ currentUserDetails?.firstname?.charAt(0)?.toUpperCase() }}{{
                                currentUserDetails?.lastname?.charAt(
                                  0)?.toUpperCase()
                              }} </p>
                          </div>

                          <div class="arrow-background">
                            <img src="assets/img/svg/arrow-down.svg" alt="Arrow down" class="cursor-pointer arrow-down">
                          </div>

                        </div>
                      </div>
                    </div>
                  }
                </div>
              </button>
              <div ngbDropdownMenu aria-labelledby="myProfileDropdown">
                <p class="fw-semibold px-3 py-3 dropdown-subtitle text-uppercase">{{ t('page.header.profile') }}</p>
                <button ngbDropdownItem (click)="onOpenProfile()">{{ t('page.header.profile.settings') }}</button>
                <button ngbDropdownItem (click)="logout()">{{ t('app.common.logout') }}</button>
              </div>
            </div>
          } @else {
            <div class="d-flex flex-xxl-grow-0 ps-4 ps-xxl-0 flex-grow-1 align-items-star">
              <div class="d-flex flex-column d-none d-xxl-flex">
                <div class="d-flex flex-row align-items-center translate-icons">
                  @if (!authenticationService.isAuthenticated()) {
                    <div class="pe-3">
                      <app-button-alt [buttonColor]="'var(--red-brand-color-500)'"
                                      [textColor]="'var(--grey-neutral-50)'" [text]="t('app.common.signup')"
                                      (onClickCallback)="goToSignup()" [buttonHeight]="'48px'"></app-button-alt>
                    </div>
                  }

                  <app-button-alt [buttonColor]="'var(--grey-1000)'" [borderColor]="'var(--red-brand-color-500)'"
                                  [textColor]="'var(--grey-neutral-50)'" [text]="t('app.common.login')"
                                  (onClickCallback)="goToLogin()" [buttonHeight]="'48px'"></app-button-alt>
                </div>
              </div>
            </div>
          }
        </div>
        <!-- SM screen only-->
        @if (!isMobileMenuVisible) {
          <div class="d-xxl-none d-flex align-items-center">
            <div class="pe-2">
              <div class="d-flex align-items-center" (click)="openLanguagesModal()" style="cursor: pointer;">
                <i class="bi bi-globe2 me-2" style="color: white;"></i>
                <p class="small" style="color: white;">{{ activeLang }}</p>
              </div>
            </div>
            <!--            @if (authenticationService.isAuthenticated()) {-->
            <!--              <ng-container *ngTemplateOutlet="messageIcon; context: { unreadMessages: unreadMessages }"></ng-container>-->
            <!--            }-->

            <div class="pe-4 cursor-pointer" (click)="toggleSearch()">
              <img src="assets/img/svg/search-icon.svg" alt="Menu">
            </div>

            <ng-template [ngTemplateOutlet]="hamburgerMenu"></ng-template>
          </div>
        } @else {
          <div class="d-xxl-none d-flex">
            <img src="assets/img/svg/close.svg" alt="Menu" (click)="toggleMobileMenuVisibility()" style="color: #FAFBFC">
          </div>
        }
      </div>
    </div>
  </header>

  <!--   Mobile menu - SM screen only-->
  <div class="slide-in-element d-xxl-none"
       [ngClass]="{'slide-in-element--with-banner': isTopBannerVisible,'slide-in-element--landing': isLanding}"
       [@slideInOut]="isMobileMenuVisible ? (isLanding ? 'inLanding' : 'in') : 'out'">

    <div class="px-4 py-3 d-flex justify-content-between align-items-center grey-neutral-50-bg mobile-menu-header">
      <div class="d-flex align-items-center">
        @if (!authenticationService.isAuthenticated()) {
          <div class="pe-2">
            <app-button-alt [buttonColor]="'white'" [borderColor]="'var(--grey-neutral-800)'"
                            [textColor]="'var(--grey-neutral-800)'" [fontSize]="'14px'" [minWidth]="'100px'"
                            [text]="t('app.common.login')" (onClickCallback)="goToLogin()"
                            [buttonHeight]="'32px'"></app-button-alt>
          </div>
          <app-button-alt [buttonColor]="'var(--red-brand-color-500)'" [fontSize]="'14px'"
                          [textColor]="'var(--grey-neutral-50)'" [text]="t('app.common.signup')" [minWidth]="'100px'"
                          (onClickCallback)="goToSignup()" [buttonHeight]="'32px'"></app-button-alt>
        } @else {
          <div class="profile-box">
            @if (currentUserDetails?.picture) {
              <div class="d-flex flex-row align-items-center">
                <div class="pe-2">
                  <div class="avatar-arrow-down">
                    <img [src]="currentUserDetails!.picture" class="avatar" alt="Avatar"/>
                  </div>
                </div>
                <div>
                  <p class="fw-semibold text-capitalize">{{ currentUserDetails?.firstname }} {{
                      currentUserDetails?.lastname
                    }}</p>
                </div>
              </div>
            } @else {
              <div class="avatar-arrow-down d-flex flex-row align-items-center">
                <div class="profile-box__initials grey-border me-2">
                  <p class="text-dark">
                    {{ currentUserDetails?.firstname?.charAt(0)?.toUpperCase() }}{{
                      currentUserDetails?.lastname?.charAt(
                        0)?.toUpperCase()
                    }} </p>
                </div>
                <div>
                  <p class="fw-semibold text-capitalize">{{ currentUserDetails?.firstname }} {{
                      currentUserDetails?.lastname
                    }}</p>
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div class="d-flex align-items-center" (click)="openLanguagesModal()" style="cursor: pointer;">
        <i class="bi bi-globe2 me-2" style="color: black;"></i>
        <p class="small" style="color: black;">{{ activeLang }}</p>
      </div>
    </div>

    <ul class="navigation-mobile pt-1" [class.landing]="isLanding">
      @if (!isLanding) {
        <li (click)="onClickToLogoImage()">{{ t('page.header.home') }}</li>
      }
      <li (click)="onEventCalendar()" [class.active]="isRouteActive('EVENT_CALENDAR')">{{
          t('page.header.event.calendar')
        }}
      </li>
      <li (click)="goToFinished()" [class.active]="isRouteActive('FINISHED')">{{
          t('page.header.finished.events')
        }}
      </li>
      <li (click)="goToLiveResults()" [class.active]="isRouteActive('LIVE_RESULTS')">{{
          t('page.header.live.results')
        }}
      </li>
      @if (environment.isLeagueVisible) {
        <li [class.active]="isRouteActive('SERIES')" (click)="goToSeries()">{{
            t('page.header.series')
          }}
        </li>
      }
      @if (authenticationService.isAuthenticated()) {
        <li (click)="goToMyTracey()" [class.active]="isRouteActive('USER_PROFILE_VIEW_ROUTE')">{{
            t('app.common.myTracey')
          }}
        </li>
        <li (click)="onOpenProfile()" [class.active]="isRouteActive('USER_PROFILE_EDIT')">{{
            t('page.header.profile.settings')
          }}
        </li>
        <li (click)="onOrganiserButtonClick()">{{
            t('page.header.organisers')
          }}
        </li>
      }

      <!-- @if (authenticationService.isAuthenticated()) {
        <div>
          <li class="toggle-icon px-3" (click)="collapseRaces.toggle()" [attr.aria-expanded]="!isRacesCollapsed">{{
              t('page.header.my.races')
            }}
          </li>
          <div #collapseRaces="ngbCollapse" [(ngbCollapse)]="isRacesCollapsed">
            <ul>
              <li (click)="goToRegistered()" [class.active]="isRouteActive('MY_REGISTERED')">{{
                  t('page.header.registered.races')
                }}
              </li>
              <li (click)="goToMyFinished()" [class.active]="isRouteActive('MY_FINISHED')">{{
                  t('page.header.my.finished.races')
                }}
              </li>
              <li (click)="goToFavorites()">{{ t('page.header.favorites.races') }}
              </li>
            </ul>
          </div>
          <li>{{ t('page.header.notifications') }}</li>
          <li (click)="onOpenProfile()">{{ t('page.header.profile.settings') }}</li>
        </div>
      } -->
      <div class="horizontal-line my-1"></div>
      <li (click)="goToContact()" class="text-capitalize" [class.active]="isRouteActive('CONTACT')">{{
          t('footer.about.contact')
        }}
      </li>
      <li (click)="goToPrivacyPolicy()" class="text-capitalize" [class.active]="isRouteActive('PRIVACY')">{{
          t('footer.privacy.policy')
        }}
      </li>
      @if (authenticationService.isAuthenticated()) {
        <div class="horizontal-line my-1"></div>
        <div class="d-flex align-items-center px-4" (click)="logout()">
          <img src="assets/img/svg/log-out.svg" alt="Menu" height="24" width="24">
          <li [class.active]="isRouteActive('SIGN_UP')" class="m-0 ps-2">{{ t('app.common.logout') }}</li>
        </div>
      }
    </ul>
  </div>
  <ng-template #hamburgerMenu>
    <div class="hamburger-button d-xxl-none" (click)="toggleMobileMenuVisibility()">
      <img src="assets/img/svg/menu-icon.svg" alt="Menu">
    </div>
  </ng-template>
</ng-container>

<ng-template #messageIcon let-unreadMessages="unreadMessages">
  <div class="d-flex align-items-center">
    <div class="pe-3">
      <ng-container *ngIf="(unreadMessages?.length ?? 0) > 0; else readIcon">
        <div class="unread-msg-circle-alt" (click)="goToMessages(false)">
          <img src="assets/icons/notification-unread.svg" alt="Unread Messages" [style.height]="'24px'"
               class="cursor-pointer">
        </div>
      </ng-container>
      <ng-template #readIcon>
        <div (click)="goToMessages(true)">
          <img src="assets/icons/notification-read.svg" alt="Messages" [style.height]="'24px'" class="cursor-pointer">
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>

